import React from "react";
import "./HomeSS.css";

const HomeSS = () => {
  return (
    <div>
      <img className="ss-1" src="ss.png" alt="hhh" />
      <div className="col-12 py-2 vv"></div>
    </div>
  );
};

export default HomeSS;
